import merge from "lodash.merge";
import * as generatedFoundations from "./generated";
import * as staticFoundations from "./static";
const mergedFoundations = merge({}, generatedFoundations, staticFoundations);
export default mergedFoundations;
//# sourceMappingURL=index.js.map